/**
 * RESPONSIBILITY: the Children's page age-groups grid.
 */
import type { ChildrenAgesSection } from '@app/sections';

export function ChildrenAges({ c }: { c: ChildrenAgesSection }) {
  const ages = c.ages ?? [];
  return (
    <section className="band">
      <div className="wrap">
        <div className="band-head"><h2>{c.agesHeading}</h2></div>
        <div className="grid grid-4">
          {ages.map((a, i) => (
            <div className="age" key={i}>
              <h3>{a.name}</h3>
              {a.ages && <p className="age-years">{a.ages}</p>}
              {a.description && <p>{a.description}</p>}
              {a.room && <p className="meta">{a.room}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
